// extracted by mini-css-extract-plugin
export default {"active_tab":"styles_active_tab__tYY3z","buynow_button":"styles_buynow_button__4gSF7","button":"styles_button__MJ1JP"};